import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a68bc21a875aa001467d6e0_1787381349820_2bc40176/monezite/src/app/problem-solution-board/components/BoardScreen.tsx");
